<ax-value-view-label [label]="label">
  <span>{{ value }}</span>
</ax-value-view-label>
